import entityContainerConnector from '~components/generic/entityContainerConnector';
import { TabItemHeader } from '~modules/tabs/TabItemHeader';

export default entityContainerConnector(TabItemHeader);
